import { z } from "zod";

const bucket = z.object({ label: z.string().max(100), lower: z.number().int().min(20), upper: z.number().int().min(29) });
export const reportingSnapshotSchema = z.object({
  contract: z.literal("helpdesk-work-records-v2"), minimum_tickets: z.number().int().min(20),
  dimensions: z.record(z.string(), z.array(bucket)),
});
export const reportingPreviewSchema = z.object({
  review: z.record(z.string(), z.number().int().nonnegative()), snapshot: reportingSnapshotSchema,
  preview_digest: z.string().regex(/^[a-f0-9]{64}$/),
});
const publicSchema = z.object({
  state: z.enum(["unpublished", "published", "withdrawn"]), snapshot: reportingSnapshotSchema.nullable(),
  published_at: z.string().nullable(), version: z.number().int().positive().nullable(),
});
export type PublicReporting = z.infer<typeof publicSchema>;
export type ReportingPreview = z.infer<typeof reportingPreviewSchema>;
export async function getPublicReporting(signal: AbortSignal): Promise<PublicReporting> {
  const response = await fetch("/api/v1/public/threat-analytics", { signal, cache: "no-store" });
  if (!response.ok) throw new Error("Community reporting is unavailable.");
  return publicSchema.parse(await response.json());
}
